import React, { useState } from 'react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import { useEffect } from 'react';
import { ButtonGroup } from '@mui/material';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export const HtmlEditor = ({name,value,onChange}) => {
  const [state,setState] = useState(()=>{
    const contentBlock = htmlToDraft(value);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
//    EditorState.createEmpty()
  });
  /*useEffect(()=>{
    if(loading) return;
    console.log('updating',loading,value);
    const contentBlock = htmlToDraft(value);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    setState(editorState);
  },[loading]);*/
  const onEditorStateChange = (editorState) => {
    const newContent = editorState.getCurrentContent();
    const oldContent = state.getCurrentContent();
    setState(editorState);
    if(newContent!=oldContent) {
      const value = draftToHtml(convertToRaw(newContent)).trim();
      console.log('hasCHANGE',newContent,oldContent);
      onChange({target:{name:name,value:value}})
    }
  }

  return <Editor
  className="obvert"
  editorState={state}
  toolbarClassName="toolbarClassName"
  wrapperClassName="wrapperClassName"
  editorClassName="editorClassName"
  onEditorStateChange={onEditorStateChange}
/>;
};
